/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue';
import Vuex from 'vuex';

import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import router from './router';
import account from './account';
import maintenance from './maintenance';
import {halClientOptions} from 'hal-client';

Vue.use(Vuex);

const store = new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    router,
    account,
    maintenance
  }
});

store.subscribe((mutation) => {
  if (mutation.type === 'account/setAccessToken') {
    halClientOptions.headers.set('Authorization', mutation.payload);
  }
});

export default store;
